var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CustomColumnType, TagType, WidgetType } from '@common/api';
import { useTagContext } from '@data/tag/tagContext';
import { useUpdateWidget, useWidgets } from '@data/widgets/widgetActions';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCallback } from 'react';
import { NEW_SHEET_ROW } from '../sheetRow/sheetRow';
import { useCreateSheetRow } from '../sheetRow/sheetRowActions';
import { useSheetRowActions, useSheetRowsById } from '../sheetRow/sheetRowHooks';
import { isAccountTag, isDimensionTag, isTableTag, isTableTagJsonData } from '../tag/types';
import { DraggableTagType, PivotZone, SingleValueZone, } from './types';
export function useTagSidebarToFinderHandler() {
    var _this = this;
    var tagData = useTagContext().tagData;
    var sheetRowsById = useSheetRowsById();
    var createSheetRow = useCreateSheetRow();
    return useCallback(function (sourceInfo, targetInfo, draggableInfo, combineDraggableInfo) { return __awaiter(_this, void 0, void 0, function () {
        var parentClusterPath, parentClusterId, tagId, tag, readonly, parentCls, children, accountChildren, accountChildren_1, accountChildren_1_1, accountChild, err_1, e_1_1;
        var e_1, _a;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    parentClusterPath = combineDraggableInfo !== undefined ? combineDraggableInfo.sheetRowPath : targetInfo.sheetRowPath;
                    parentClusterId = Number.parseInt((_b = parentClusterPath.split('_').pop()) !== null && _b !== void 0 ? _b : '');
                    if (Number.isNaN(parentClusterId)) {
                        // cancel action if no cluster is selected
                        return [2 /*return*/, { status: 'error', message: 'Cluster not found' }];
                    }
                    tagId = draggableInfo.tagId;
                    tag = tagData.tagById[tagId];
                    if (!tag && draggableInfo.tagType !== DraggableTagType.AccountTable) {
                        return [2 /*return*/, { status: 'error', message: 'Tag not found' }];
                    }
                    readonly = false;
                    parentCls = parentClusterId ? sheetRowsById[parentClusterId] : null;
                    if (parentCls) {
                        readonly = parentCls.readonly;
                    }
                    if (!(draggableInfo.tagType === DraggableTagType.AccountTable)) return [3 /*break*/, 11];
                    children = (_c = tagData.tagsByParentId[tagId ? tagId : 'null']) !== null && _c !== void 0 ? _c : [];
                    accountChildren = children.filter(function (tag) { return tag.type === TagType.Account; });
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 8, 9, 10]);
                    accountChildren_1 = __values(accountChildren), accountChildren_1_1 = accountChildren_1.next();
                    _e.label = 2;
                case 2:
                    if (!!accountChildren_1_1.done) return [3 /*break*/, 7];
                    accountChild = accountChildren_1_1.value;
                    _e.label = 3;
                case 3:
                    _e.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, createSheetRow.mutateAsync(__assign(__assign({}, NEW_SHEET_ROW), { name: accountChild.name, parentId: parentClusterId === 0 ? null : parentClusterId, accountTagId: accountChild.id, readonly: readonly }))];
                case 4:
                    _e.sent();
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _e.sent();
                    return [2 /*return*/, { status: 'error', message: 'Failed creating row' }];
                case 6:
                    accountChildren_1_1 = accountChildren_1.next();
                    return [3 /*break*/, 2];
                case 7: return [3 /*break*/, 10];
                case 8:
                    e_1_1 = _e.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 10];
                case 9:
                    try {
                        if (accountChildren_1_1 && !accountChildren_1_1.done && (_a = accountChildren_1.return)) _a.call(accountChildren_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 10: return [3 /*break*/, 12];
                case 11:
                    try {
                        createSheetRow.mutate(__assign(__assign({}, NEW_SHEET_ROW), { name: (_d = tag === null || tag === void 0 ? void 0 : tag.name) !== null && _d !== void 0 ? _d : NEW_SHEET_ROW.name, parentId: parentClusterId == 0 ? null : parentClusterId, tableTagId: isTableTag(tag) ? tag.id : null, accountTagId: isAccountTag(tag) ? tag.id : null, dimensionTagIds: isDimensionTag(tag) ? [tag.id] : [], readonly: readonly }));
                    }
                    catch (err) {
                        return [2 /*return*/, { status: 'error', message: 'Failed creating cluster' }];
                    }
                    _e.label = 12;
                case 12: return [2 /*return*/, { status: 'success', message: 'Row created' }];
            }
        });
    }); }, [tagData]);
}
export function useTagSidebarToTagSidebarHandler() {
    return useCallback(function (sourceInfo, targetInfo, draggableInfo, combineDraggableInfo, targetIndex) {
        // WIP
        // useful for reordering elements?
        // currently isDropDisabled = true on Droppable
        return { status: 'error', message: 'Not implemented yet' };
    }, []);
}
export function useTagSidebarToSingleValueWidgetHandler() {
    var _this = this;
    var _a;
    var widgets = (_a = useWidgets().data) !== null && _a !== void 0 ? _a : [];
    var tagData = useTagContext().tagData;
    var updateWidgetMutation = useUpdateWidget();
    return useCallback(function (sourceInfo, targetInfo, draggableInfo) { return __awaiter(_this, void 0, void 0, function () {
        var tag, widget, widgetConfig, widgetZone, field;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tag = tagData.tagById[draggableInfo.tagId];
                    if (tag === undefined) {
                        return [2 /*return*/, { status: 'error', message: 'Tag not found' }];
                    }
                    widget = widgets.find(function (w) { return w.id === targetInfo.widgetId; });
                    if (widget === undefined) {
                        return [2 /*return*/, { status: 'error', message: 'Widget not found' }];
                    }
                    widgetConfig = parseWidgetConfig(widget.config, WidgetType.SINGLEVALUE);
                    widgetZone = targetInfo.zone;
                    if (!(widgetZone === SingleValueZone.Variable)) return [3 /*break*/, 4];
                    if (!(tag.type === TagType.Account)) return [3 /*break*/, 3];
                    if (!!widgetConfig.accountTags.includes(tag.id)) return [3 /*break*/, 2];
                    widgetConfig.accountTags = [tag.id];
                    return [4 /*yield*/, updateWidgetMutation.mutateAsync(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, { status: 'success' }];
                case 3: return [2 /*return*/, { status: 'error', message: 'Variable field should contain varables only' }];
                case 4:
                    if (!(widgetZone === SingleValueZone.Filter || widgetZone === SingleValueZone.Comparison)) return [3 /*break*/, 8];
                    field = widgetZone === SingleValueZone.Filter ? 'filterTags' : 'comparisonTags';
                    if (!(tag.type === TagType.Dimension)) return [3 /*break*/, 7];
                    if (!!widgetConfig[field].includes(tag.id)) return [3 /*break*/, 6];
                    widgetConfig[field].push(tag.id);
                    return [4 /*yield*/, updateWidgetMutation.mutateAsync(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }))];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/, { status: 'success' }];
                case 7: return [2 /*return*/, { status: 'error', message: "".concat(widgetZone, " field should contain dimension tags") }];
                case 8: return [2 /*return*/, { status: 'error', message: 'Unknown zone in single value' }];
            }
        });
    }); }, [widgets, tagData, updateWidgetMutation]);
}
export function useTagSidebarToPivotWidgetHandler() {
    var _this = this;
    var _a;
    var widgets = (_a = useWidgets().data) !== null && _a !== void 0 ? _a : [];
    var tagData = useTagContext().tagData;
    var updateWidgetMutation = useUpdateWidget();
    return useCallback(function (sourceInfo, targetInfo, draggableInfo) { return __awaiter(_this, void 0, void 0, function () {
        var tag, widget, widgetConfig, widgetZone, _a, _b, variableRow, variableRow_1, variableRow_1_1, variableField, columnHeader, rowHeader, _c, _d, variableRow, variableField, variableRow, variableRow_2, variableRow_2_1, variableField, variableZone;
        var e_2, _e, e_3, _f, e_4, _g, e_5, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    tag = tagData.tagById[draggableInfo.tagId];
                    if (tag === undefined) {
                        return [2 /*return*/, { status: 'error', message: 'Tag not found' }];
                    }
                    widget = widgets.find(function (w) { return w.id === targetInfo.widgetId; });
                    if (widget === undefined) {
                        return [2 /*return*/, { status: 'error', message: 'Widget not found' }];
                    }
                    widgetConfig = parseWidgetConfig(widget.config, WidgetType.PIVOT);
                    widgetZone = targetInfo.zone;
                    if (!(widgetZone === PivotZone.Filter)) return [3 /*break*/, 6];
                    if (!(tag.type === TagType.Dimension)) return [3 /*break*/, 3];
                    if (!!widgetConfig.filters.includes(tag.id)) return [3 /*break*/, 2];
                    widgetConfig.filters.push(tag.id);
                    return [4 /*yield*/, updateWidgetMutation.mutateAsync(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }))];
                case 1:
                    _j.sent();
                    _j.label = 2;
                case 2: return [2 /*return*/, { status: 'success' }];
                case 3:
                    if (!(tag.type === TagType.Account)) return [3 /*break*/, 5];
                    try {
                        // if account tag is dropped, add to all variable fields
                        for (_a = __values(widgetConfig.variables), _b = _a.next(); !_b.done; _b = _a.next()) {
                            variableRow = _b.value;
                            try {
                                for (variableRow_1 = (e_3 = void 0, __values(variableRow)), variableRow_1_1 = variableRow_1.next(); !variableRow_1_1.done; variableRow_1_1 = variableRow_1.next()) {
                                    variableField = variableRow_1_1.value;
                                    if (!variableField.includes(tag.id)) {
                                        variableField.push(tag.id);
                                    }
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (variableRow_1_1 && !variableRow_1_1.done && (_f = variableRow_1.return)) _f.call(variableRow_1);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    return [4 /*yield*/, updateWidgetMutation.mutateAsync(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }))];
                case 4:
                    _j.sent();
                    return [2 /*return*/, { status: 'success' }];
                case 5: return [2 /*return*/, { status: 'error', message: 'Filter field should contain dimension tags' }];
                case 6:
                    if (!(widgetZone === PivotZone.Column || widgetZone === PivotZone.Row)) return [3 /*break*/, 18];
                    if (!(tag.type === TagType.Table || tag.type === TagType.Dimension)) return [3 /*break*/, 12];
                    if (!(widgetZone === PivotZone.Column)) return [3 /*break*/, 9];
                    columnHeader = widgetConfig.columns[targetInfo.columnIndex];
                    if (!!columnHeader.includes(tag.id)) return [3 /*break*/, 8];
                    columnHeader.push(tag.id);
                    return [4 /*yield*/, updateWidgetMutation.mutateAsync(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }))];
                case 7:
                    _j.sent();
                    return [2 /*return*/, { status: 'success' }];
                case 8: return [3 /*break*/, 11];
                case 9:
                    if (!(widgetZone === PivotZone.Row)) return [3 /*break*/, 11];
                    rowHeader = widgetConfig.rows[targetInfo.rowIndex];
                    if (!!rowHeader.includes(tag.id)) return [3 /*break*/, 11];
                    rowHeader.push(tag.id);
                    return [4 /*yield*/, updateWidgetMutation.mutateAsync(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }))];
                case 10:
                    _j.sent();
                    return [2 /*return*/, { status: 'success' }];
                case 11: return [2 /*return*/, { status: 'error', message: 'Unknown zone in data editor' }];
                case 12:
                    if (!(tag.type === TagType.Account)) return [3 /*break*/, 17];
                    if (!(widgetZone === PivotZone.Column)) return [3 /*break*/, 14];
                    try {
                        for (_c = __values(widgetConfig.variables), _d = _c.next(); !_d.done; _d = _c.next()) {
                            variableRow = _d.value;
                            variableField = variableRow[targetInfo.columnIndex];
                            if (!variableField.includes(tag.id)) {
                                variableField.push(tag.id);
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_g = _c.return)) _g.call(_c);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    return [4 /*yield*/, updateWidgetMutation.mutateAsync(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }))];
                case 13:
                    _j.sent();
                    return [2 /*return*/, { status: 'success' }];
                case 14:
                    if (!(widgetZone === PivotZone.Row)) return [3 /*break*/, 16];
                    variableRow = widgetConfig.variables[targetInfo.rowIndex];
                    try {
                        for (variableRow_2 = __values(variableRow), variableRow_2_1 = variableRow_2.next(); !variableRow_2_1.done; variableRow_2_1 = variableRow_2.next()) {
                            variableField = variableRow_2_1.value;
                            if (!variableField.includes(tag.id)) {
                                variableField.push(tag.id);
                            }
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (variableRow_2_1 && !variableRow_2_1.done && (_h = variableRow_2.return)) _h.call(variableRow_2);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                    return [4 /*yield*/, updateWidgetMutation.mutateAsync(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }))];
                case 15:
                    _j.sent();
                    return [2 /*return*/, { status: 'success' }];
                case 16: return [2 /*return*/, { status: 'error', message: 'Unknown zone in data editor' }];
                case 17: return [2 /*return*/, { status: 'error', message: "".concat(widgetZone, " field should contain table or dimension tags") }];
                case 18:
                    if (!(widgetZone === PivotZone.Variable)) return [3 /*break*/, 22];
                    if (!(tag.type === TagType.Account)) return [3 /*break*/, 21];
                    variableZone = widgetConfig.variables[targetInfo.rowIndex][targetInfo.columnIndex];
                    if (!!variableZone.includes(tag.id)) return [3 /*break*/, 20];
                    variableZone.push(tag.id);
                    return [4 /*yield*/, updateWidgetMutation.mutateAsync(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }))];
                case 19:
                    _j.sent();
                    _j.label = 20;
                case 20: return [2 /*return*/, { status: 'success' }];
                case 21: return [2 /*return*/, { status: 'error', message: 'Variable field should contain account tags' }];
                case 22: return [2 /*return*/, { status: 'error', message: 'Unknown zone in data editor' }];
            }
        });
    }); }, [widgets, tagData, updateWidgetMutation]);
}
export function useTagSidebarToModelCustomColumnHandler() {
    var _this = this;
    var sheetRowsById = useSheetRowsById();
    var editSheetRow = useSheetRowActions().editSheetRow;
    var tagData = useTagContext().tagData;
    return useCallback(function (sourceInfo, targetInfo, draggableInfo) { return __awaiter(_this, void 0, void 0, function () {
        var customColIdx, sheetRowId, tagId, tagType, tagPropertyId, sheetRow, tag, customCols, column, noColumnType, newColDimensions;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    customColIdx = targetInfo.customColumnIndex;
                    sheetRowId = targetInfo.sheetRowId;
                    tagId = draggableInfo.tagId;
                    tagType = draggableInfo.tagType;
                    tagPropertyId = draggableInfo.tagPropertyId;
                    sheetRow = sheetRowsById[sheetRowId];
                    if (!sheetRow) {
                        return [2 /*return*/, { status: 'error', message: 'No row selected' }];
                    }
                    tag = tagData.tagById[tagId];
                    if (!tag) {
                        return [2 /*return*/, { status: 'error', message: 'Tag not found' }];
                    }
                    customCols = sheetRow.customColumns ? __spreadArray([], __read(sheetRow.customColumns), false) : [];
                    column = customCols[customColIdx]
                        ? __assign({}, customCols[customColIdx]) : undefined;
                    if (!column) {
                        return [2 /*return*/, { status: 'error', message: 'Custom column not found' }];
                    }
                    noColumnType = column.type === undefined;
                    if (tagType === DraggableTagType.Account) {
                        if (noColumnType || column.type === CustomColumnType.Number) {
                            column.type = CustomColumnType.Number;
                            column.accountTagId = tagId;
                            column.dimensionTagIds = column.dimensionTagIds ? column.dimensionTagIds : [];
                        }
                        else {
                            return [2 /*return*/, {
                                    status: 'error',
                                    message: "Can't add account to column type ".concat((_a = column.type) === null || _a === void 0 ? void 0 : _a.toLowerCase()),
                                }];
                        }
                    }
                    else if (tagType === DraggableTagType.Dimension) {
                        if (noColumnType || column.type === CustomColumnType.Number) {
                            column.type = CustomColumnType.Number;
                            column.accountTagId = column.accountTagId ? column.accountTagId : null;
                            newColDimensions = column.dimensionTagIds ? __spreadArray([], __read(column.dimensionTagIds), false) : [];
                            if (!newColDimensions.includes(tagId)) {
                                newColDimensions.push(tagId);
                            }
                            else {
                                return [2 /*return*/, {
                                        status: 'error',
                                        message: "This tag is already added",
                                    }];
                            }
                            column.dimensionTagIds = newColDimensions;
                        }
                        else {
                            return [2 /*return*/, {
                                    status: 'error',
                                    message: "Can't add dimension to column type ".concat((_b = column.type) === null || _b === void 0 ? void 0 : _b.toLowerCase()),
                                }];
                        }
                    }
                    else if (tagType === DraggableTagType.Table && !column.property) {
                        if (noColumnType || column.type === CustomColumnType.Table) {
                            column.name = tag.name;
                            column.type = CustomColumnType.Table;
                            column.tableTagId = tagId;
                        }
                        else {
                            return [2 /*return*/, { status: 'error', message: "Can't add table to column type ".concat((_c = column.type) === null || _c === void 0 ? void 0 : _c.toLowerCase()) }];
                        }
                    }
                    else {
                        if (tagPropertyId && (noColumnType || column.property)) {
                            column.name = isTableTagJsonData(tag.jsonData)
                                ? (_e = (_d = tag.jsonData.headers.find(function (h) { return h.uniqueId === tagPropertyId; })) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : ''
                                : '';
                            column.type = CustomColumnType.Table;
                            column.tableTagId = tagId;
                            column.property = tagPropertyId;
                        }
                        else {
                            return [2 /*return*/, {
                                    status: 'error',
                                    message: "Can't add property to column type property",
                                }];
                        }
                    }
                    customCols[customColIdx] = column;
                    return [4 /*yield*/, editSheetRow(__assign(__assign({}, sheetRow), { customColumns: customCols }))];
                case 1:
                    _f.sent();
                    return [2 /*return*/, { status: 'success' }];
            }
        });
    }); }, [sheetRowsById, editSheetRow, tagData]);
}
